import { lazy, Suspense } from "react";
import { BrowserRouter, HashRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { MainLayout } from "./layouts/MainLayout";
import { ResumenTab } from "./pages/ResumenTab";
import "./App.css";

const Roadmap = lazy(() => import("./views/Roadmap").then(m => ({ default: m.Roadmap })));
const AsignaturasTab = lazy(() => import("./pages/AsignaturasTab").then(m => ({ default: m.AsignaturasTab })));
const HorariosView = lazy(() => import("./views/HorariosView").then(m => ({ default: m.HorariosView })));
const Notes = lazy(() => import("./views/Notes").then(m => ({ default: m.Notes })));
const ConfigTab = lazy(() => import("./pages/ConfigTab").then(m => ({ default: m.ConfigTab })));
const LandingPage = lazy(() => import("./components/LandingPage").then(m => ({ default: m.LandingPage })));

function PageFallback() {
  return (
    <div className="w-full h-full p-6 animate-pulse space-y-4">
      <div className="h-8 w-48 bg-slate-200 rounded-lg" />
      <div className="h-64 w-full bg-slate-100 rounded-2xl border border-slate-200/60" />
    </div>
  );
}

function App() {
  const isWeb = typeof window !== 'undefined' && (
    window.location.hostname.includes('pages.dev') ||
    window.location.hostname.includes('facultad-track')
  );
  const Router = isWeb ? BrowserRouter : HashRouter;

  return (
    <Router>
      <Toaster 
        position="bottom-right" 
        toastOptions={{ 
          className: "font-sans shadow-lg rounded-xl border border-slate-200/80 bg-white text-slate-900 text-xs font-medium"
        }} 
      />
      <Suspense fallback={<PageFallback />}>
        <Routes>
          {/* Landing Page principal en la raíz '/' */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/landing" element={<LandingPage />} />

          {/* Rutas de la aplicación Malla en /app y /dashboard */}
          <Route path="/app" element={<MainLayout />}>
            <Route index element={<ResumenTab />} />
            <Route path="roadmap" element={<Roadmap />} />
            <Route path="asignaturas" element={<AsignaturasTab />} />
            <Route path="horarios" element={<HorariosView />} />
            <Route path="notas" element={<Notes />} />
            <Route path="config" element={<ConfigTab />} />
          </Route>

          <Route path="/dashboard" element={<MainLayout />}>
            <Route index element={<ResumenTab />} />
            <Route path="roadmap" element={<Roadmap />} />
            <Route path="asignaturas" element={<AsignaturasTab />} />
            <Route path="horarios" element={<HorariosView />} />
            <Route path="notas" element={<Notes />} />
            <Route path="config" element={<ConfigTab />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;

